import { ApiLog } from 'dashboard/models/api-log';
import Action from 'lib/interfaces/Action';

export type ApiLogActions =
  | Action<ApiLogActionType.ClearApiLog>
  | Action<ApiLogActionType.SetApiLog, SetApiLogPayload>;

export enum ApiLogActionType {
  ClearApiLog = 'api-log/CLEAR_API_LOG',
  SetApiLog = 'api-log/SET_API_LOG',
}

export function clearApiLog(): Action<ApiLogActionType.ClearApiLog> {
  return { type: ApiLogActionType.ClearApiLog };
}

interface SetApiLogPayload {
  apiLog: ApiLog;
}

export function setApiLog(apiLog: ApiLog): Action<ApiLogActionType.SetApiLog, SetApiLogPayload> {
  return {
    payload: {
      apiLog,
    },
    type: ApiLogActionType.SetApiLog,
  };
}
